var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.onlyRead
        ? _c(
            "div",
            { staticClass: "uploadBox" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo mr10 mb15",
                  attrs: {
                    action: "##",
                    headers: _vm.myHeaders,
                    "show-file-list": false,
                    "http-request": _vm.uploadServerLog,
                    multiple: "",
                  },
                },
                [
                  !_vm.percentShow
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.fileList.length >= _vm.maxLength &&
                              _vm.maxLength !== 0,
                            size: "small",
                          },
                        },
                        [_vm._v("添加")]
                      )
                    : _c("div", { staticClass: "addText" }, [
                        _c("img", {
                          staticClass: "l_gif",
                          attrs: {
                            src: require("../../assets/images/loading.gif"),
                            alt: "",
                          },
                        }),
                      ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fileList.length > 0
        ? _c("upload-list", {
            attrs: { "file-list": _vm.fileList, "show-close": !_vm.onlyRead },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }